if (!customElements.get('content-popup')) {
  class ContentPopup extends ModalDialog {
    constructor() {
      super();
      this.setOverflowHidden = this.dataset.overflowHidden == 'true';
      this.storageKey = this.dataset.key
      this.delay = +this.dataset.delay || 0;
      
      if (localStorage.getItem(this.storageKey) === "true") return;
      if (sessionStorage.getItem(this.storageKey) === "true") return;

      this.currentScroll = 0;
      this.setCurrentScroll();

      this.permanentCloseInput = this.querySelector('.content-popup__checkbox--input');
      if (this.permanentCloseInput) {
        this.permanentClosed = this.permanentCloseInput.checked || false;
        this.permanentCloseInput.addEventListener('change', this.onPermanentCloseChange.bind(this))
      }

      this.boundOnScroll = this.onScroll.bind(this);

      if (this.currentScroll >= this.dataset.scrollPercentage) {
        this.showPopup();
      } else {
        window.addEventListener('scroll', this.boundOnScroll);
      }
    }

    showPopup() {
      window.removeEventListener('scroll', this.boundOnScroll);
      if (localStorage.getItem(this.storageKey) === "true") return;
      if (sessionStorage.getItem(this.storageKey) === "true") return;
      setTimeout(() => {
        this.show();
      }, this.delay);
    }

    onPermanentCloseChange(event) {
      this.permanentClosed = event.target.checked
    }
    hide() {
      // Always open on Editor
      if (!Shopify.designMode) {
        if (this.permanentClosed) {
          localStorage.setItem(this.storageKey, "true");
        } else {
          sessionStorage.setItem(this.storageKey, "true");
        }
      }
      super.hide();
    }

    setCurrentScroll() {
      this.currentScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
    }

    onScroll() {
      const documentHeight = document.documentElement.scrollHeight;
      this.setCurrentScroll();
      const currentPercentage = this.currentScroll / (documentHeight - window.innerHeight);

      if (currentPercentage >= this.dataset.scrollPercentage) {
        this.showPopup();
      }

    }

  }
  
  customElements.define('content-popup', ContentPopup);
  
  class NewsletterPopup extends ContentPopup {
    constructor() {
      super();

      if (this.dataset.customerSubscribed == 'true' && !this.querySelector('.newsletter-form__message--success')) {
        setTimeout(() => {
          super.hide();
        }, this.delay + 1);
      }

      this.suscribeButton = this.querySelector('[data-newsletter-button]');
      if (this.suscribeButton) {
        this.suscribeButton.addEventListener('click', this.onSubscribeClick.bind(this));
      }
    }

    onSubscribeClick() {
      sessionStorage.setItem(this.storageKey, "true");
      localStorage.setItem(this.storageKey, "true");

      setTimeout(() => {
        super.hide();
        const href = this.suscribeButton.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      }, this.delay + 1);
    }
  }

  customElements.define('newsletter-popup', NewsletterPopup);
}